/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Patient from "./Patient";
import { qreq } from "../shared/qrequest";
import Globals from "../shared/Globals";
import LoadingAlert from "./LoadingAlert";
import Alert from "./Alert";
import Card from "./Card";
import FormInput from "./FormInput";
import SignatureCanvas from "react-signature-canvas";
import Icon from "./Icon";
import React from "react";

class QuoteSignRequest extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
        this.sigCanvasRef = React.createRef();
        this.submit = this.submit.bind(this);
    }

    async componentDidMount() {
        await this.loadRequest();
    }

    loadRequest = async () => {
        try {
            let j = await qreq.getAsync('/api/quote/request/get/' + this.props.params.uniqueIdent + '/public');
            if (j.item) {
                this.setState({
                    item: j.item,
                    quote: j.item.quote,
                    account: j.item.account,
                    org: j.item.organization
                });
            }
            else
                this.setState({ error: j.errorMessage });
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    submit(e) {
        if (e) e.preventDefault();
        if (this.sigCanvasRef.current.isEmpty()) {
            this.alert('Please sign the form before submitting.');
            return;
        }
        var info = { ...this.state.item, ...this.state.info };
        info.base64Signature = this.sigCanvasRef.current.getTrimmedCanvas().toDataURL('image/png').split(',')[1];
        this.setState({ submitting: true });
        qreq.post('/api/quote/request/sign', info, j => {
            if (j.errorCode === 0) {
                this.setState({ success: true });
            }
            else {
                this.setState({ submitting: false });
                this.alert(j.errorMessage);
            }
        }, () => {
            this.setState({ submitting: false });
            this.unkownErrorCallback();
        });
    }

    render() {
        if (this.state.error)
            return <div className="container-fluid"><h1>Error</h1><Alert type="warning">{this.state.error}</Alert></div>;
        if (!this.state.item)
            return <LoadingAlert />
        if (this.state.success)
            return <div className="container-fluid"><h1>Success</h1><Alert type="success">Quote signed successfully.</Alert><p>You may now close this page.</p></div>;

        return <div className="container-fluid">
            <div className="u-document">
                <form onSubmit={this.submit}>
                    <div className="container mt-5">
                        <div className="text-center">
                            <img src={Globals.getImageURL(this.state.org?.logoURL)} alt=""
                                className="img-fluid" style={{ maxWidth: '10rem' }} />
                        </div>
                        <div className="text-center p-3">
                            <strong>{this.state.org?.name}</strong>
                            <strong> | </strong>
                            <strong>{this.state.org?.address?.line1} {this.state.org?.address?.line2}</strong>
                            <strong> | </strong>
                            <strong>{this.state.org?.address?.city} {this.state.org?.address?.state} {this.state.org?.address?.postalCode}</strong>
                        </div>
                        <div className="clearfix"></div>
                        <div className="row">
                            <h2>{this.state.account?.name}</h2>
                            <div className="col-10 text-start">
                                <strong><u>Client Legal Name &amp; Address</u></strong>
                                <br />
                                <div><strong>{this.state.account?.name}</strong></div>
                                <div>{this.state.account?.address?.line1}</div>
                                <div>{this.state.account?.address?.line2}</div>
                                <div>{this.state.account?.address?.city} {this.state.account?.address?.state} {this.state.account?.address?.postalCode}</div>
                            </div>
                            <div className="col-2 text-end">
                                <table className="table table-borderless table-header">
                                    <tbody>
                                        <tr>
                                            <td colspan="2" className="text-center"><strong><u>Quote</u></strong></td>
                                        </tr>
                                        <tr>
                                            <th>#</th>
                                            <td className="text-start">{this.state.quote?.qid}</td>
                                        </tr>
                                        <tr>
                                            <th>Date</th>
                                            <td className="text-start">{Globals.toMDYDateString(this.state.quote?.quoteDate)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="clearfix"></div>
                    </div>
                    <div className="container mb-3">
                        <h4>Description</h4>
                        <div dangerouslySetInnerHTML={{ __html: this.processHTML(this.state.quote?.description) }}></div>
                        <h4>Amount</h4>
                        <div dangerouslySetInnerHTML={{ __html: this.processHTML(this.state.quote?.amountVerbage) }}></div>
                        <h4>Timeline</h4>
                        <div dangerouslySetInnerHTML={{ __html: this.processHTML(this.state.quote?.timeline) }}></div>
                        <h4>Terms</h4>
                        <div dangerouslySetInnerHTML={{ __html: this.processHTML(this.state.quote?.terms) }}></div>

                    </div>
                    <Card title="Signee Information">
                        <FormInput model={this.state.info} name="signName" label="Full Name of Signee" type="text" required placeholder="Full Name..." autoFocus />
                    </Card>

                    <Card title="Signature">
                        <div className="text-center">
                            <label className="form-label">Signature of Individual or Individual's Legally Authorized Representative</label>
                        </div>
                        <div className="d-grid align-items-center justify-content-center">
                            <button type="button" className="btn btn-secondary" onClick={() => this.sigCanvasRef.current.clear()}>Reset Signature</button>
                            <SignatureCanvas ref={this.sigCanvasRef} canvasProps={{ width: 400, height: 200, className: 'border' }} />
                        </div>
                        <div className="my-3 text-center">
                            <button type="submit" className="btn btn-primary btn-lg" disabled={this.state.submitting}><Icon icon="faCaretRight" /> Submit</button>
                        </div>
                    </Card>
                </form>
            </div>
        </div>;
    }
}

export default withParamsAndNavigate(QuoteSignRequest);